// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.social-media-container-enhanced {
  padding: 3rem 2rem;
  background-color: #ffffff;
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
  max-width: 900px;
  margin: 3rem auto;
  overflow: hidden;
  position: relative;
}

.social-media-container-enhanced::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 8px;
  background: linear-gradient(90deg, #4776E6, #8E54E9);
}

.social-media-header {
  text-align: center;
  margin-bottom: 3rem;
  position: relative;
}

.social-media-title-enhanced {
  font-size: 2.5rem;
  font-weight: 700;
  color: #333;
  margin-bottom: 0.5rem;
  position: relative;
  display: inline-block;
}

.social-media-title-underline {
  width: 80px;
  height: 4px;
  background: linear-gradient(90deg, #4776E6, #8E54E9);
  margin: 0.5rem auto 1.5rem;
  border-radius: 2px;
  position: relative;
  overflow: hidden;
}

.social-media-title-underline::after {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, rgba(255,255,255,0.3), rgba(255,255,255,0.6), rgba(255,255,255,0.3));
  animation: shimmer 2s infinite;
}

.social-media-subtitle-enhanced {
  font-size: 1.1rem;
  color: #666;
  max-width: 600px;
  margin: 0 auto;
  line-height: 1.6;
}

.social-media-links-enhanced {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 2rem;
}

.social-media-item-enhanced {
  display: flex;
  align-items: center;
  padding: 1.5rem;
  background-color: #f8f9fa;
  border-radius: 12px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.05);
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  cursor: pointer;
  width: 320px;
  position: relative;
  overflow: hidden;
  opacity: 0;
  transform: translateY(30px);
}

.social-media-item-enhanced.visible {
  opacity: 1;
  transform: translateY(0);
}

.social-media-item-enhanced:hover, 
.social-media-item-enhanced.hovered {
  transform: translateY(-8px) scale(1.02);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
}

.social-media-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
  opacity: 0;
  transition: opacity 0.4s ease;
}

.social-media-item-enhanced.social-media-btn-fb .social-media-background {
  background: linear-gradient(135deg, rgba(66, 103, 178, 0.1), rgba(66, 103, 178, 0.05));
}

.social-media-item-enhanced.social-media-btn-tiktok .social-media-background {
  background: linear-gradient(135deg, rgba(238, 29, 82, 0.1), rgba(0, 0, 0, 0.05));
}

.social-media-item-enhanced:hover .social-media-background,
.social-media-item-enhanced.hovered .social-media-background {
  opacity: 1;
}

.social-media-icon-wrapper {
  position: relative;
  margin-right: 1.5rem;
}

.social-media-icon-container-enhanced {
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  overflow: hidden;
  background-color: white;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  position: relative;
  z-index: 2;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.social-media-item-enhanced:hover .social-media-icon-container-enhanced,
.social-media-item-enhanced.hovered .social-media-icon-container-enhanced {
  transform: scale(1.1);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}

.social-media-icon-enhanced {
  width: 65%;
  height: 65%;
  object-fit: contain;
  transition: transform 0.5s ease;
}

.social-media-item-enhanced:hover .social-media-icon-enhanced,
.social-media-item-enhanced.hovered .social-media-icon-enhanced {
  transform: scale(1.15) rotate(5deg);
}

.social-media-pulse {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: transparent;
  z-index: 1;
}

.social-media-item-enhanced:hover .social-media-pulse::before,
.social-media-item-enhanced:hover .social-media-pulse::after,
.social-media-item-enhanced.hovered .social-media-pulse::before,
.social-media-item-enhanced.hovered .social-media-pulse::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  animation: pulse 2s infinite;
}

.social-media-item-enhanced.social-media-btn-fb:hover .social-media-pulse::before,
.social-media-item-enhanced.social-media-btn-fb.hovered .social-media-pulse::before {
  border: 2px solid rgba(66, 103, 178, 0.3);
  animation-delay: 0.5s;
}

.social-media-item-enhanced.social-media-btn-fb:hover .social-media-pulse::after,
.social-media-item-enhanced.social-media-btn-fb.hovered .social-media-pulse::after {
  border: 2px solid rgba(66, 103, 178, 0.3);
}

.social-media-item-enhanced.social-media-btn-tiktok:hover .social-media-pulse::before,
.social-media-item-enhanced.social-media-btn-tiktok.hovered .social-media-pulse::before {
  border: 2px solid rgba(238, 29, 82, 0.3);
  animation-delay: 0.5s;
}

.social-media-item-enhanced.social-media-btn-tiktok:hover .social-media-pulse::after,
.social-media-item-enhanced.social-media-btn-tiktok.hovered .social-media-pulse::after {
  border: 2px solid rgba(238, 29, 82, 0.3);
}

.social-media-info-enhanced {
  flex-grow: 1;
  position: relative;
  z-index: 2;
}

.social-media-name-enhanced {
  font-size: 1.4rem;
  font-weight: 600;
  color: #333;
  margin: 0 0 0.25rem 0;
  transition: color 0.3s ease;
}

.social-media-item-enhanced.social-media-btn-fb:hover .social-media-name-enhanced,
.social-media-item-enhanced.social-media-btn-fb.hovered .social-media-name-enhanced {
  color: #4267B2;
}

.social-media-item-enhanced.social-media-btn-tiktok:hover .social-media-name-enhanced,
.social-media-item-enhanced.social-media-btn-tiktok.hovered .social-media-name-enhanced {
  color: #EE1D52;
}

.social-media-link-enhanced {
  font-size: 0.9rem;
  color: #888;
  margin: 0 0 1rem 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: color 0.3s ease;
}

.social-media-item-enhanced:hover .social-media-link-enhanced,
.social-media-item-enhanced.hovered .social-media-link-enhanced {
  color: #666;
}

.social-media-cta {
  display: flex;
  align-items: center;
  font-size: 0.9rem;
  font-weight: 600;
  color: #555;
  opacity: 0;
  transform: translateY(10px);
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.social-media-item-enhanced:hover .social-media-cta,
.social-media-item-enhanced.hovered .social-media-cta {
  opacity: 1;
  transform: translateY(0);
}

.social-media-cta-text {
  margin-right: 0.5rem;
}

.social-media-cta-arrow {
  transition: transform 0.3s ease;
}

.social-media-item-enhanced:hover .social-media-cta-arrow,
.social-media-item-enhanced.hovered .social-media-cta-arrow {
  transform: translateX(5px);
}

/* Facebook specific styling */
.social-media-item-enhanced.social-media-btn-fb .social-media-icon-container-enhanced {
  background-color: rgba(66, 103, 178, 0.1);
}

.social-media-item-enhanced.social-media-btn-fb:hover .social-media-cta,
.social-media-item-enhanced.social-media-btn-fb.hovered .social-media-cta {
  color: #4267B2;
}

/* TikTok specific styling */
.social-media-item-enhanced.social-media-btn-tiktok .social-media-icon-container-enhanced {
  background-color: rgba(238, 29, 82, 0.1);
}

.social-media-item-enhanced.social-media-btn-tiktok:hover .social-media-cta,
.social-media-item-enhanced.social-media-btn-tiktok.hovered .social-media-cta {
  color: #EE1D52;
}

/* Animations */
@keyframes pulse {
  0% {
    transform: scale(1);
    opacity: 0.8;
  }
  70% {
    transform: scale(1.5);
    opacity: 0;
  }
  100% {
    transform: scale(1.5);
    opacity: 0;
  }
}

@keyframes shimmer {
  0% {
    left: -100%;
  }
  100% {
    left: 100%;
  }
}

/* Responsive design */
@media (max-width: 768px) {
  .social-media-container-enhanced {
    padding: 2rem 1.5rem;
  }
  
  .social-media-title-enhanced {
    font-size: 2rem;
  }
  
  .social-media-links-enhanced {
    flex-direction: column;
    align-items: center;
  }
  
  .social-media-item-enhanced {
    width: 100%;
    max-width: 350px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/SocialMedia/SocialMediaLinksEnhanced.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,2CAA2C;EAC3C,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,WAAW;EACX,oDAAoD;AACtD;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,oDAAoD;EACpD,0BAA0B;EAC1B,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,uGAAuG;EACvG,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,0CAA0C;EAC1C,4DAA4D;EAC5D,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;;EAEE,uCAAuC;EACvC,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,WAAW;EACX,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,sFAAsF;AACxF;;AAEA;EACE,gFAAgF;AAClF;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,yCAAyC;EACzC,kBAAkB;EAClB,UAAU;EACV,qDAAqD;AACvD;;AAEA;;EAEE,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,UAAU;AACZ;;AAEA;;;;EAIE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;;EAEE,yCAAyC;EACzC,qBAAqB;AACvB;;AAEA;;EAEE,yCAAyC;AAC3C;;AAEA;;EAEE,wCAAwC;EACxC,qBAAqB;AACvB;;AAEA;;EAEE,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,UAAU;EACV,2BAA2B;EAC3B,kDAAkD;AACpD;;AAEA;;EAEE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA,8BAA8B;AAC9B;EACE,yCAAyC;AAC3C;;AAEA;;EAEE,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE,wCAAwC;AAC1C;;AAEA;;EAEE,cAAc;AAChB;;AAEA,eAAe;AACf;EACE;IACE,mBAAmB;IACnB,YAAY;EACd;EACA;IACE,qBAAqB;IACrB,UAAU;EACZ;EACA;IACE,qBAAqB;IACrB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;AACF","sourcesContent":[".social-media-container-enhanced {\n  padding: 3rem 2rem;\n  background-color: #ffffff;\n  border-radius: 16px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);\n  max-width: 900px;\n  margin: 3rem auto;\n  overflow: hidden;\n  position: relative;\n}\n\n.social-media-container-enhanced::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 8px;\n  background: linear-gradient(90deg, #4776E6, #8E54E9);\n}\n\n.social-media-header {\n  text-align: center;\n  margin-bottom: 3rem;\n  position: relative;\n}\n\n.social-media-title-enhanced {\n  font-size: 2.5rem;\n  font-weight: 700;\n  color: #333;\n  margin-bottom: 0.5rem;\n  position: relative;\n  display: inline-block;\n}\n\n.social-media-title-underline {\n  width: 80px;\n  height: 4px;\n  background: linear-gradient(90deg, #4776E6, #8E54E9);\n  margin: 0.5rem auto 1.5rem;\n  border-radius: 2px;\n  position: relative;\n  overflow: hidden;\n}\n\n.social-media-title-underline::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(90deg, rgba(255,255,255,0.3), rgba(255,255,255,0.6), rgba(255,255,255,0.3));\n  animation: shimmer 2s infinite;\n}\n\n.social-media-subtitle-enhanced {\n  font-size: 1.1rem;\n  color: #666;\n  max-width: 600px;\n  margin: 0 auto;\n  line-height: 1.6;\n}\n\n.social-media-links-enhanced {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 2rem;\n}\n\n.social-media-item-enhanced {\n  display: flex;\n  align-items: center;\n  padding: 1.5rem;\n  background-color: #f8f9fa;\n  border-radius: 12px;\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.05);\n  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n  cursor: pointer;\n  width: 320px;\n  position: relative;\n  overflow: hidden;\n  opacity: 0;\n  transform: translateY(30px);\n}\n\n.social-media-item-enhanced.visible {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n.social-media-item-enhanced:hover, \n.social-media-item-enhanced.hovered {\n  transform: translateY(-8px) scale(1.02);\n  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);\n}\n\n.social-media-background {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: -1;\n  opacity: 0;\n  transition: opacity 0.4s ease;\n}\n\n.social-media-item-enhanced.social-media-btn-fb .social-media-background {\n  background: linear-gradient(135deg, rgba(66, 103, 178, 0.1), rgba(66, 103, 178, 0.05));\n}\n\n.social-media-item-enhanced.social-media-btn-tiktok .social-media-background {\n  background: linear-gradient(135deg, rgba(238, 29, 82, 0.1), rgba(0, 0, 0, 0.05));\n}\n\n.social-media-item-enhanced:hover .social-media-background,\n.social-media-item-enhanced.hovered .social-media-background {\n  opacity: 1;\n}\n\n.social-media-icon-wrapper {\n  position: relative;\n  margin-right: 1.5rem;\n}\n\n.social-media-icon-container-enhanced {\n  width: 60px;\n  height: 60px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  overflow: hidden;\n  background-color: white;\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);\n  position: relative;\n  z-index: 2;\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n.social-media-item-enhanced:hover .social-media-icon-container-enhanced,\n.social-media-item-enhanced.hovered .social-media-icon-container-enhanced {\n  transform: scale(1.1);\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);\n}\n\n.social-media-icon-enhanced {\n  width: 65%;\n  height: 65%;\n  object-fit: contain;\n  transition: transform 0.5s ease;\n}\n\n.social-media-item-enhanced:hover .social-media-icon-enhanced,\n.social-media-item-enhanced.hovered .social-media-icon-enhanced {\n  transform: scale(1.15) rotate(5deg);\n}\n\n.social-media-pulse {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 60px;\n  height: 60px;\n  border-radius: 50%;\n  background-color: transparent;\n  z-index: 1;\n}\n\n.social-media-item-enhanced:hover .social-media-pulse::before,\n.social-media-item-enhanced:hover .social-media-pulse::after,\n.social-media-item-enhanced.hovered .social-media-pulse::before,\n.social-media-item-enhanced.hovered .social-media-pulse::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  animation: pulse 2s infinite;\n}\n\n.social-media-item-enhanced.social-media-btn-fb:hover .social-media-pulse::before,\n.social-media-item-enhanced.social-media-btn-fb.hovered .social-media-pulse::before {\n  border: 2px solid rgba(66, 103, 178, 0.3);\n  animation-delay: 0.5s;\n}\n\n.social-media-item-enhanced.social-media-btn-fb:hover .social-media-pulse::after,\n.social-media-item-enhanced.social-media-btn-fb.hovered .social-media-pulse::after {\n  border: 2px solid rgba(66, 103, 178, 0.3);\n}\n\n.social-media-item-enhanced.social-media-btn-tiktok:hover .social-media-pulse::before,\n.social-media-item-enhanced.social-media-btn-tiktok.hovered .social-media-pulse::before {\n  border: 2px solid rgba(238, 29, 82, 0.3);\n  animation-delay: 0.5s;\n}\n\n.social-media-item-enhanced.social-media-btn-tiktok:hover .social-media-pulse::after,\n.social-media-item-enhanced.social-media-btn-tiktok.hovered .social-media-pulse::after {\n  border: 2px solid rgba(238, 29, 82, 0.3);\n}\n\n.social-media-info-enhanced {\n  flex-grow: 1;\n  position: relative;\n  z-index: 2;\n}\n\n.social-media-name-enhanced {\n  font-size: 1.4rem;\n  font-weight: 600;\n  color: #333;\n  margin: 0 0 0.25rem 0;\n  transition: color 0.3s ease;\n}\n\n.social-media-item-enhanced.social-media-btn-fb:hover .social-media-name-enhanced,\n.social-media-item-enhanced.social-media-btn-fb.hovered .social-media-name-enhanced {\n  color: #4267B2;\n}\n\n.social-media-item-enhanced.social-media-btn-tiktok:hover .social-media-name-enhanced,\n.social-media-item-enhanced.social-media-btn-tiktok.hovered .social-media-name-enhanced {\n  color: #EE1D52;\n}\n\n.social-media-link-enhanced {\n  font-size: 0.9rem;\n  color: #888;\n  margin: 0 0 1rem 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  transition: color 0.3s ease;\n}\n\n.social-media-item-enhanced:hover .social-media-link-enhanced,\n.social-media-item-enhanced.hovered .social-media-link-enhanced {\n  color: #666;\n}\n\n.social-media-cta {\n  display: flex;\n  align-items: center;\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: #555;\n  opacity: 0;\n  transform: translateY(10px);\n  transition: opacity 0.3s ease, transform 0.3s ease;\n}\n\n.social-media-item-enhanced:hover .social-media-cta,\n.social-media-item-enhanced.hovered .social-media-cta {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n.social-media-cta-text {\n  margin-right: 0.5rem;\n}\n\n.social-media-cta-arrow {\n  transition: transform 0.3s ease;\n}\n\n.social-media-item-enhanced:hover .social-media-cta-arrow,\n.social-media-item-enhanced.hovered .social-media-cta-arrow {\n  transform: translateX(5px);\n}\n\n/* Facebook specific styling */\n.social-media-item-enhanced.social-media-btn-fb .social-media-icon-container-enhanced {\n  background-color: rgba(66, 103, 178, 0.1);\n}\n\n.social-media-item-enhanced.social-media-btn-fb:hover .social-media-cta,\n.social-media-item-enhanced.social-media-btn-fb.hovered .social-media-cta {\n  color: #4267B2;\n}\n\n/* TikTok specific styling */\n.social-media-item-enhanced.social-media-btn-tiktok .social-media-icon-container-enhanced {\n  background-color: rgba(238, 29, 82, 0.1);\n}\n\n.social-media-item-enhanced.social-media-btn-tiktok:hover .social-media-cta,\n.social-media-item-enhanced.social-media-btn-tiktok.hovered .social-media-cta {\n  color: #EE1D52;\n}\n\n/* Animations */\n@keyframes pulse {\n  0% {\n    transform: scale(1);\n    opacity: 0.8;\n  }\n  70% {\n    transform: scale(1.5);\n    opacity: 0;\n  }\n  100% {\n    transform: scale(1.5);\n    opacity: 0;\n  }\n}\n\n@keyframes shimmer {\n  0% {\n    left: -100%;\n  }\n  100% {\n    left: 100%;\n  }\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n  .social-media-container-enhanced {\n    padding: 2rem 1.5rem;\n  }\n  \n  .social-media-title-enhanced {\n    font-size: 2rem;\n  }\n  \n  .social-media-links-enhanced {\n    flex-direction: column;\n    align-items: center;\n  }\n  \n  .social-media-item-enhanced {\n    width: 100%;\n    max-width: 350px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
